export default __webpack_public_path__ + "static/media/categorie_icons_Invite.b4cad499.svg";